var libCommon = function(){}

module.exports = {
  formatDate: function (date, fmt) {
    if(/(y+)/.test(fmt)){
      fmt = fmt.replace(RegExp.$1, (date.getFullYear()+'').substr(4-RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth()+1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for(let k in o){
      let str = o[k]+'';
      if(new RegExp(`(${k})`).test(fmt)){
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length===1)?str:libCommon.padLeftZero(str));
      }
    }
    return fmt;
  },
  /**
   * base64转binary（文件载下时可用）
   * @param base64，格式如：data:application/pdf;base64,xxxxxxxxx
   */
  base64ToBinary: function (base64) {
    return libCommon.base64toBlob(libCommon.getBase64Data(base64), libCommon.getFileContentType(base64));
  },
  /**
   * base64转为Uint8Array
   * @param base64
   * @returns {Uint8Array}
   */
  base64toUint8Array: function (base64) {
    base64 = base64.replace(/[\r\n]/g,'');
    let raw = window.atob(base64);
    let buf = new ArrayBuffer(raw.length);
    let u16a = new Uint8Array(buf);
    for (var i = 0; i < raw.length; i++) {
      u16a[i] = raw.charCodeAt(i);
    }
    return u16a;
  },
}

libCommon.padLeftZero = function (str) {
  return ('00'+str).substr(str.length);
}
/**
 * 获取base64文件类型，参数格式如下
 * data:application/pdf;base64,xxxxxxxxx
 */
libCommon.getFileContentType = function(base64) {
  return /data:([^;]*);/i.exec(base64)[1];
}
/**
 * 获取base64文件除了文件头的内容数据
 * @param base64，格式如：data:application/pdf;base64,xxxxxxxxx
 * @returns {string | *}
 */
libCommon.getBase64Data = function(base64) {
  return base64.substr(base64.indexOf("base64,") + 7, base64.length);
}
/**
 * 将base64转为BLOB (binary large object)，二进制大对象
 * @param b64Data
 * @param contentType
 * @param sliceSize
 * @returns {Blob}
 */
libCommon.base64toBlob = function(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  let byteCharacters = atob(b64Data);
  let byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);

    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  let blob = new Blob(byteArrays, { type: contentType });
  return blob;
}



// WEBPACK FOOTER //
// ./src/libs/common.js